//hooks
import useIsClient from '@stencil/hotels-hooks/src/useIsClient';

const SeoAboutProperty = () => {
  const isClient = useIsClient();

  return (
    <div
      id="seoAboutDontRemoveContainer"
      data-testid="seoAboutDontRemoveContainer"
      dangerouslySetInnerHTML={{
        __html: isClient ? window?.hotelsseocms?.aboutContent : '',
      }}
    ></div>
  );
};

export default SeoAboutProperty;
